import { useQuery, useQueryClient, useMutation } from 'react-query';
import axios from 'axios';

// Custom hook for tax rates data
export function useTaxRatesData(options = {}) {
  const { data: taxRateData = {}, ...props } = useQuery(
    ['tax-rates'],
    () => axios.get('/api/taxrate').then(response => response.data),
    {
      refetchInterval: latestData => {
        if (latestData?.settings?.updating) return 1000;
        return false;
      },
      ...options
    }
  );

  return { taxRateData, ...props };
}


// Custom hook for updating WA tax rates
export function useUpdateTaxRates() {
  const queryClient = useQueryClient();

  const { mutateAsync: updateTaxRates, ...props } = useMutation(
    () => axios.post('/api/taxrate/update'),
    {
      onSettled: () => {
        queryClient.invalidateQueries(['tax-rates']);
      }
    }
  );

  return { updateTaxRates, ...props };
}
